// extracted by mini-css-extract-plugin
export default {"browser_top":"browser_top___WvU0Y","browser_text":"browser_text___boFbp","browser_bg":"browser_bg___CHORL","browser_interface":"browser_interface___U56m3"};